<mat-toolbar *ngIf="footer_visible">
    <img  src="assets/images/whooosh_schriftzug.svg" [matMenuTriggerFor]="menuAbout" class="whoooshSchriftzugMitLink" height="20px" alt="">
    <img  src="assets/images/whooosh_schriftzug.svg" class="whoooshSchriftzugohneLink" height="20px" alt="">
    <span class="linkLeftInFooter" [matMenuTriggerFor]="menuAbout">
        <mat-icon>expand_more</mat-icon>
    </span>
        <div class="linkCenterInFooter" >
            <span class="linkInFotter" *ngFor="let linksforFooter of tilesaboutwhooosh" >
                <span routerLink="{{linksforFooter.link}}" *ngIf="linksforFooter.text != 'language_keyword_$11'" translate>{{linksforFooter.text}}</span>
                <span *ngIf="linksforFooter.text == 'language_keyword_$11'" [matMenuTriggerFor]="menu" translate>{{linksforFooter.text}}</span>
            </span>
        </div>
    <span class="example-spacer"></span>
    <!-- <span class="linkInFotterFromBerlin" tourAnchor="startTour" [matMenuTriggerFor]="menuColor">{{'keyword_$360' | translate}}</span><span [matMenuTriggerFor]="menuColor" class="redHeart"><mat-icon>favorite</mat-icon></span> -->
    <span class="linkInFotterFromBerlin"  tourAnchor="createTour" tourAnchor="startTour" >{{'keyword_$360' | translate}}</span><span  class="redHeart"><mat-icon>favorite</mat-icon></span>
</mat-toolbar>

<mat-menu #menu="matMenu">
    <button mat-menu-item (click)="switchLanguage('ch')"
          routerLinkActive=" w--current">
          <span class="flag-icon flag-icon-cn "></span> {{ 'language_keyword_$3' | translate }}
    </button>
    <button mat-menu-item (click)="switchLanguage('de')"
          routerLinkActive=" w--current">
          <span class="flag-icon flag-icon-de "></span> {{ 'language_keyword_$2' | translate }}
    </button>
    <button mat-menu-item (click)="switchLanguage('en')"
          routerLinkActive=" w--current">
          <span class="flag-icon flag-icon-gb "></span> {{ 'language_keyword_$1' | translate }}
    </button>
    <button mat-menu-item (click)="switchLanguage('fr')"
          routerLinkActive=" w--current">
          <span class="flag-icon flag-icon-fr "></span> {{ 'language_keyword_$5' | translate }}
    </button>
    <button mat-menu-item (click)="switchLanguage('it')"
          routerLinkActive=" w--current">
          <span class="flag-icon flag-icon-it "></span> {{ 'language_keyword_$4' | translate }}
    </button>
    <button mat-menu-item (click)="switchLanguage('ja')"
          routerLinkActive=" w--current">
          <span class="flag-icon flag-icon-jp "></span> {{ 'language_keyword_$6' | translate }}
    </button>
    <button mat-menu-item (click)="switchLanguage('po')"
          routerLinkActive=" w--current">
          <span class="flag-icon flag-icon-pl "></span> {{ 'language_keyword_$7' | translate }}
    </button>
    <button mat-menu-item (click)="switchLanguage('ru')"
          routerLinkActive=" w--current">
          <span class="flag-icon flag-icon-ru "></span> {{ 'language_keyword_$8' | translate }}
    </button>
    <button mat-menu-item (click)="switchLanguage('sp')"
          routerLinkActive=" w--current">
          <span class="flag-icon flag-icon-es "></span> {{ 'language_keyword_$9' | translate }}
    </button>
    <button mat-menu-item (click)="switchLanguage('tu')"
          routerLinkActive=" w--current">
          <span class="flag-icon flag-icon-tr "></span> {{ 'language_keyword_$10' | translate }}
    </button>
</mat-menu>

<!-- <mat-menu #menuColor="matMenu">
    <button mat-menu-item (click)="switchTheme('night')">
           {{ 'keyword_$361' | translate }}
    </button>
    <button mat-menu-item (click)="switchTheme('day')">
         {{ 'keyword_$362' | translate }}
    </button>
</mat-menu> -->

<mat-menu #menuAbout="matMenu" class="menuContentAbout"    >
    <div class="menuButton"  >
        <div class="menuItem" align="left" routerLink="/terms" >
            <div class="menuTextLeft" >
                <span class="mdi mdi-gavel"></span> {{ 'keyword_$103' | translate }}
            </div>
        </div>
        <div class="menuItem" align="left" routerLink="/contact" >
            <div class="menuTextLeft" >
                <span class="mdi mdi-contact-mail"></span> {{ 'keyword_$266' | translate }}
            </div>
        </div>
        <div class="menuItem" align="left" routerLink="/policies" >
            <div class="menuTextLeft" >
                <span class="mdi mdi-security"></span> {{ 'keyword_$104' | translate }}
            </div>
        </div>
        <div class="menuItem" align="left" routerLink="/imprint" >
            <div class="menuTextLeft" >
                <span class="mdi mdi-home-modern"></span> {{ 'keyword_$102' | translate }}
            </div>
        </div>
        <button mat-menu-item class="menuItem"  [matMenuTriggerFor]="menu"> {{ 'language_keyword_$11' | translate }}</button>


    </div>
</mat-menu>
<!-- <div *ngIf="!isUserLoggedIn && whoooshie_visible" class="krakeDesktop">
    <img src="assets/images/krake.gif" tourAnchor="finishTour" (click)="startToutByClickOnWhoooshie()" matTooltip="{{'keyword_$407' | translate}}" class="krakeLeftFixed" height="150px" alt="">
</div> -->


<!-- <mat-menu #menuAbout="matMenu">
    <button mat-menu-item *ngFor="let linksforFooter of tilesaboutwhooosh">
        <button mat-menu-item *ngIf="linksforFooter.text == 'language_keyword_$11'" [matMenuTriggerFor]="menu">{{ linksforFooter.text | translate }}</button>
        <button routerLink="{{linksforFooter.link}}" mat-menu-item *ngIf="linksforFooter.text != 'language_keyword_$11'">{{ linksforFooter.text | translate }}</button>
    </button>
</mat-menu> -->
